import moment from 'moment';
import { SpaEntityType } from 'shared-types/Spa';
import { isGuestAlreadyInArray } from '@utils/helpers';

export const parseSpaEntityData = (data: any, spaEntity: SpaEntityType, entityType: string) => {
  const checkIn = moment(data.arrivalTime.startDateTime).format();
  const checkOut = moment(data.arrivalTime.endDateTime).format();

  return {
    quantity: 1,
    type: entityType,
    checkIn,
    checkOut,
    note: data.notes,
    guestDetails: data.guests.map((guest) => {
      const extras: any[] = [];
      if (data.extras) {
        const availableExtrasIds = Object.keys(data.extras);
        availableExtrasIds.forEach((extrasId) => {
          if (
            data.extras[extrasId] &&
            isGuestAlreadyInArray(
              data.extras[extrasId].map((el) => el.value),
              guest
            )
          ) {
            extras.push({
              id: parseInt(extrasId.split('-')[1], 10),
            });
          }
        });
      }
      return {
        ...(guest.externalSpaId && { externalSpaId: guest.externalSpaId }),
        ...(guest.id && { id: guest.id }),
        title: guest.title,
        firstName: guest.firstName,
        lastName: guest.lastName,
        gender: guest.gender,
        extras,
      };
    }),
    bookable: {
      ids: {
        id: spaEntity.id,
        type: entityType,
      },
    },
  };
};
